import { useContext } from 'react';
import { LightBoxContext } from './LightBoxContext';

export const useLightBox = () => useContext(LightBoxContext);
